import React from "react";
import Marquee from "react-fast-marquee";
import { SiMcdonalds, SiIkea, SiTesla } from "react-icons/si";
import { FaAmazon } from "react-icons/fa6";
import { Reveal, Label } from "./anim";
import { MARKETS } from "../data/content";

const CLIENT_LOGOS = [
  { name: "McDonald's", Icon: SiMcdonalds },
  { name: "Amazon", Icon: FaAmazon },
  { name: "IKEA", Icon: SiIkea },
  { name: "Tesla", Icon: SiTesla },
  { name: "Walmart", Icon: null },
  { name: "Dick's Sporting Goods", Icon: null },
  { name: "Fabletics", Icon: null },
  { name: "Toll Brothers", Icon: null },
];

export const Clients = () => {
  return (
    <section data-testid="clients-section" className="relative bg-[#EFEBDE] py-20 md:py-28 overflow-hidden border-t border-[#16281C]/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 mb-12">
        <Reveal>
          <Label>Trusted On Projects For</Label>
        </Reveal>
      </div>
      <Marquee speed={40} gradient gradientColor="#EFEBDE" gradientWidth={120} autoFill>
        {CLIENT_LOGOS.map((c) => (
          <div
            key={c.name}
            className="mx-10 md:mx-16 flex items-center h-14 text-[#16281C]/45 hover:text-[#2C5F3A] transition-colors"
            title={c.name}
          >
            {c.Icon ? (
              <c.Icon className="h-10 w-auto md:h-12" size={48} aria-label={c.name} />
            ) : (
              <span className="font-display font-semibold text-3xl md:text-4xl tracking-tight whitespace-nowrap">
                {c.name}
              </span>
            )}
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export const Markets = () => {
  return (
    <section data-testid="markets-section" className="relative bg-[#2C5F3A] py-24 md:py-40 overflow-hidden">
      {/* hollow drifting editorial marquee */}
      <div className="absolute inset-0 flex flex-col justify-center gap-2 pointer-events-none">
        <Marquee speed={30} autoFill>
          <span className="font-display font-bold uppercase text-[13vw] leading-none tracking-tighter mx-6 [-webkit-text-stroke:1px_rgba(239,235,222,0.35)] text-transparent">
            All 50 States —
          </span>
        </Marquee>
        <Marquee speed={30} direction="right" autoFill>
          <span className="font-display font-bold uppercase text-[13vw] leading-none tracking-tighter mx-6 [-webkit-text-stroke:1.5px_rgba(239,235,222,0.6)] text-transparent">
            Nationwide AHJ —
          </span>
        </Marquee>
      </div>

      <div className="relative max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="bg-[#2C5F3A]/70 backdrop-blur-sm inline-block">
            <span className="font-mono text-xs tracking-[0.25em] uppercase text-[#EFEBDE]/80">Markets Covered</span>
            <h2 className="mt-6 font-display font-semibold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-2xl text-[#EFEBDE]">
              Relationships in every major metro.
            </h2>
          </div>
        </Reveal>

        <div className="mt-16 md:mt-24 flex flex-wrap gap-3 max-w-5xl">
          {MARKETS.map((m, i) => (
            <Reveal key={m} delay={i * 0.02}>
              <span className="inline-block bg-[#244E30] border border-[#EFEBDE]/15 px-5 py-3 font-mono text-xs md:text-sm tracking-[0.1em] uppercase text-[#EFEBDE]/85 hover:bg-[#EFEBDE] hover:text-[#2C5F3A] transition-colors">
                {m}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
